export default "__VITE_ASSET__BrHHQcN1__"